import React from 'react';
import { withRouter } from 'react-router-dom';
import IncidentCardBasic from './IncidentCardBasic';
import IncidentCardRelationships from './IncidentCardRelationships';
import IncidentCardStats from './IncidentCardStats';
import * as CardFields from '../../../defaults/DetailsCard.json';

const IncidentOverview = props => {
  return (
    <div className="details-card-container">
      <IncidentCardBasic
        title="Identifiers"
        fields={CardFields.incident.identifiers}
        attributes={props.item && props.item.attributes}
      />
      <IncidentCardBasic
        title="Sync"
        fields={CardFields.incident.sync}
        attributes={props.item && props.item.attributes}
      />
      <IncidentCardRelationships
        title="Relationships"
        incident={props.item}
        labels={CardFields.incident.relationshipLabels}
      />
      <IncidentCardStats
        title="Stats"
        stats={props.stats}
        labels={CardFields.incident.statsLabels}
      />
    </div>
  );
};

export default withRouter(IncidentOverview);



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/IncidentOverview.js